import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumbs } from '@mui/material';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type BreadcrumbsProps = {
  children?: ReactNode;
  breadcrumbs: { label: string; path?: string }[];
};

export const HeaderBreadcrumbs = (props: BreadcrumbsProps) => {
  return (
    <Breadcrumbs
      sx={{ '& a': { color: '#616161', textDecoration: 'none' } }}
      separator={<FontAwesomeIcon icon={faChevronRight} />}
    >
      {props.breadcrumbs.map(b =>
        b.path ? (
          <Link to={b.path} key={b.path}>
            {b.label}
          </Link>
        ) : (
          b.label
        )
      )}
    </Breadcrumbs>
  );
};
